import { GoogleAdminIcon } from '@atlassian/logo-third-party/google-admin';
import { MicrosoftEntraIDIcon } from '@atlassian/logo-third-party/microsoft-entra-id';
import { WorkdayIcon } from '@atlassian/logo-third-party/workday';

import type { PeopleDataProvider } from '../../utils/people-data-providers';

export const providers: Record<PeopleDataProvider, { name: string; Icon: typeof WorkdayIcon }> = {
	workday: { name: 'Workday', Icon: WorkdayIcon },
	google: { name: 'Google', Icon: GoogleAdminIcon },
	microsoft: { name: 'Microsoft', Icon: MicrosoftEntraIDIcon },
};
